var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconParking = function SvgIconParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0C225 0 0 225 0 500s225 500 500 500 500-225 500-500S775 0 500 0Zm0 900c-220 0-400-180-400-400s180-400 400-400 400 180 400 400-180 400-400 400Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M575 250H350v500h100V600h125c95 0 175-80 175-175s-80-175-175-175Zm0 250H450V350h125c40 0 75 35 75 75s-35 75-75 75Z"
  })));
};
export default SvgIconParking;